module.exports = __webpack_public_path__ + "img/gift2-pc.741b70d6.png";